import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_URL + '/api/product';

class ProductService {
    get(id, location_id = null) {
        if (location_id) {
            id = id + '?location_id=' + location_id;
        }
        return axios.get(API_URL + '/' + id, { headers: authHeader() });
    }

    getCategory(id, location_id = null) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/product_category';
        if (location_id) {
            id = id + '?location_id=' + location_id;
        }
        return axios.get(url + '/' + id, { headers: authHeader() });
    }

    getAllCategory(type = 'all', page = 1, limit = 'all', location_id = null) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getAll/product_category?type=' + type + '&page=' + page + '&limit=' + limit;
        if (location_id) {
            url = url + '&location_id=' + location_id;
        }
        return axios.get(url, { headers: authHeader() });
    }

    getByProductDetailId(id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/getProductByProductDetailId';
        return axios.get(url + '/' + id, { headers: authHeader() });
    }

    getProductAddon(id) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/product_addon';
        return axios.get(url + '/' + id, { headers: authHeader() });
    }

    getDetailByDetailId(data) {
        let url = process.env.VUE_APP_BACKEND_URL + '/api/product_detail/getById';
        return axios.post(url, data, { headers: authHeader() });
    }
}

export default new ProductService();
